import { useDispatch, useSelector } from "react-redux";
import type { RootState, AppDispatch } from "store/store";

// eslint-disable-next-line
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
// eslint-disable-next-line
export const useAppSelector = useSelector.withTypes<RootState>();
